import { defaultTheme } from '../styles/index'

export default defaultTheme
